import * as React from 'react'
import HTag from 'components/common/HTag'
import Img from 'components/common/Img'

const SimpleTitle = ({ heading, image }) => (
	<section className="grid *:col-span-full *:row-span-full">
		<Img
			className="pointer-events-none max-h-[max(250px,20svh)] w-full opacity-20 grayscale <md:max-h-[150px]"
			image={image}
			objectFit="cover"
			alt={heading?.text}
		/>

		<header className="relative z-[1] grid place-content-center p-4 text-center">
			<HTag className="h3 technical-lg" {...heading} />
		</header>
	</section>
)

export default SimpleTitle
